export default "__VITE_ASSET__D40re5rU__"